import { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, ListGroup } from 'react-bootstrap';
import { getTransactionDocuments, getTransactionDocumentUrl, getTransactionLetterUrl, getTitleApplicationForTransactionUrl, getBillOfSaleForTransactionUrl, getSaleTitleDocumentForTransactionUrl } from '../../utils/api';
import Loader from '../Loader';
import { openDocumentInNewTab } from '../../utils/helpers';
import Error from '../Error';
import PdfPreviewModal from './PdfPreviewModal';


const TransactionRequestDocumentsModal = ({ show, onHide, transaction }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [showPdfPreviewModal, setShowPdfPreviewModal] = useState(false);
    const [pdfPreviewData, setPdfPreviewData] = useState(null);


    useEffect(() => {
        const fetchData = async () => {
            if (show) {
                setLoading(true);
                const data = transaction && await getTransactionDocuments(transaction.Id);
                if (data) {
                    setData(data);
                }
                else {
                    setError('Failed to fetch data');
                }
                setLoading(false);
            }
            else {
                setData([]);
                setError(null);
                setLoading(false);
            }
        };
        fetchData();
    }, [show]);

    const documentClicked = async (d) => {

        var obj = { title: d?.Name };
        obj.url = await getTransactionDocumentUrl(d.Id, transaction.Id, true);
        obj.downloadUrl = await getTransactionDocumentUrl(d.Id, transaction.Id, false);

        // var title = d?.Name?.toLowerCase()?.trim();
        // if (title === 'transaction letter') {
        //     obj.url = await getTransactionLetterUrl(transaction.Id, true);
        //     obj.downloadUrl = await getTransactionLetterUrl(transaction.Id, false);
        // }
        // else if (title === 'title application') {
        //     obj.url = await getTitleApplicationForTransactionUrl(transaction.Id, true);
        //     obj.downloadUrl = await getTitleApplicationForTransactionUrl(transaction.Id, false);
        // }
        // else if (title === 'bill of sale') {
        //     obj.url = await getBillOfSaleForTransactionUrl(transaction.Id, true);
        //     obj.downloadUrl = await getBillOfSaleForTransactionUrl(transaction.Id, false);
        // }
        // else if (title === 'sale title document') {
        //     obj.url = await getSaleTitleDocumentForTransactionUrl(transaction.Id, true);
        //     obj.downloadUrl = await getSaleTitleDocumentForTransactionUrl(transaction.Id, false);
        // }

        setPdfPreviewData(obj);
        setShowPdfPreviewModal(true);
    }

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{'Request Documents for Transaction (Id=' + transaction?.Id + ')'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : (
                            <>
                                <Row>
                                    <Col md={12}>
                                        <ListGroup>
                                            {data?.map((d, idx) => (
                                                <ListGroup.Item key={idx}>{
                                                    <Row key={d.Name}>
                                                        <Col md={10}>
                                                            <span>{d.Name}</span>
                                                            <br />
                                                            <span>{d.Description}</span>
                                                        </Col>
                                                        <Col md={2} className="d-flex align-items-center justify-content-end">
                                                            <Button variant={d.IsEnabled ? 'primary' : 'secondary'} disabled={!d.IsEnabled} onClick={() => documentClicked(d)}>Generate</Button>
                                                        </Col>
                                                    </Row>
                                                }</ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal >

            <PdfPreviewModal
                show={showPdfPreviewModal}
                onHide={() => setShowPdfPreviewModal(false)}
                data={pdfPreviewData} />
        </>
    );
};

export default TransactionRequestDocumentsModal;